"use strict";require('@ebay/skin/menu');